<template>
  <div class="container2 mx-6" align="center" >
    <div class=" pt-5 mb-12" ><h6 class="link" @click.prevent="goTo()">Accedi come comune</h6>
    </div>
    <div class="d-flex justify-content-center">
          <div  class="col mx-auto my-12 ">
            <h1 >Comuni registrati</h1>
           <ul class="list-group-flush p-0 mt-4"
            v-for="comune in comuni"
          :key="comune.codiceCatasto">
        <li class="list-group-item inhome"><h5 class="link" @click.prevent="set(comune.codiceCatasto)">Comune di {{comune.nome}}</h5></li>
            <li class="list-group-item m-0 p-0 inhome"></li></ul>
          </div>
          </div>
  </div>
</template>

<script>
import ComuniDataService from '@/service/ComuniDataService.js'

export default {
  name: 'Home1',

  data () {
    return {
      comuni: []
    }
  },
  methods: {
    loadComuni () {
      return ComuniDataService
        .getComuni()
        .then(response => {
          console.log(response.data)
          return response.data
        })
        .catch(e => {
          console.log(e)
          return []
        })
    },
    set (comid) {
      this.$store.dispatch('setComune', comid)
      this.$store.dispatch('setTheme', comid)
      this.$router.push({ name: 'Home', params: { cid: comid } })
    },
    clear () {
      this.$store.dispatch('clearStore')
      this.$store.dispatch('setTheme', '')
    },
    goTo () {
      this.$router.push({ name: 'LogComune' })
    }
  },
  created () {
    this.clear()
    this.loadComuni().then(risultato => {
      console.log(risultato)
      this.comuni = risultato
    })
  }
}
</script>
